// サイト基本設定。株式会社イケメン 採用メディア。
export const siteConfig = {
  name: process.env.NEXT_PUBLIC_SITE_NAME || "IKEMEN",
  nameJa: "株式会社イケメン 採用サイト",
  companyName: "株式会社イケメン",
  companyNameEn: "IKEMEN Co., Ltd.",
  logo: "/logo-ikemen.png",
  logoWhite: "/logo-ikemen-white.png", // 濃色背景（フッター）用：文字を白に置換・teal顔は維持
  logoWidth: 1226,
  logoHeight: 265,
  // 理念「世の中のかっこいいを再定義する」に合わせたタグライン。
  tagline: "Choose the cool one.",
  taglineJa: "かっこいい選択を、し続ける。",
  description:
    "株式会社イケメンの採用オウンドメディア。代表とメンバーの実際の言葉から、私たちの事業・文化・働き方をお届けします。",
  url: process.env.NEXT_PUBLIC_SITE_URL || "http://localhost:3000",
  corporateUrl: "https://ikemen.ltd",
  entryUrl: "/recruit",
  nav: [
    { label: "すべての記事", labelEn: "All", href: "/interview" },
    { label: "仕事を知る", labelEn: "Work", href: "/category/work" },
    { label: "働く人", labelEn: "People", href: "/category/people" },
    { label: "制度・環境", labelEn: "Culture", href: "/category/culture" },
    { label: "募集中の求人", labelEn: "Jobs", href: "/jobs" },
    { label: "募集要項", labelEn: "Recruit", href: "/recruit" },
  ],
  // 自社アカウントのURLを入れると、フッターにアイコンが出る。
  // 空のままなら何も表示しない（プラットフォームのトップへ飛ぶ空リンクを出さないため）。
  social: {
    x: "",
    instagram: "",
    linkedin: "",
  },
  contactEmail: "info@ikemen.ltd",
  address: "〒141-0032 東京都品川区大崎4-4-24 ラ・リュールオオサキ301",
};

export type SiteConfig = typeof siteConfig;
